import { 
    GET_INPUT_HISTORY,
    SET_INPUT_HISTORY 
} from './types';

export const getInputHistory = (state) => dispatch => {
    dispatch({
        type: GET_INPUT_HISTORY,
        payload: state
    });
}

export const setInputHistory = (history) => dispatch => {
    dispatch({
        type: SET_INPUT_HISTORY,
        payload: history
    });
}


// WEBPACK FOOTER //
// ./src/actions/inputActions.js